import {HTMLAttributes, ReactNode} from 'react';
import {cn} from '../../libs';

interface SidebarGroupProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  divider?: boolean;
}

export const SidebarGroup = ({children, ...rest}: SidebarGroupProps) => {
  return <div className={cn('mb-6 last:mb-0', rest.className)}>{children}</div>;
};
